import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PartModel } from '../project-controller/project-controller';

@Injectable({
  providedIn: 'root',
})
export class PartListControllerService {
  private _selectedPartList: Array<PartModel> = [];
  private _selectedPartList$: BehaviorSubject<Array<PartModel>> = new BehaviorSubject<
    Array<PartModel>
  >(this._selectedPartList);

  private _categoryMap: Map<string, PartModel> = new Map<string, PartModel>();
  private _categoryMap$: BehaviorSubject<Map<string, PartModel>> = new BehaviorSubject<
    Map<string, PartModel>
  >(this._categoryMap);

  constructor() {}

  get selectedPartList$() {
    return this._selectedPartList$;
  }

  get selectedPartList() {
    return this._selectedPartList;
  }

  get categoryMap$() {
    return this._categoryMap$;
  }

  get categoryMap() {
    return this._categoryMap;
  }

  addPart(part: PartModel) {
    part.isSelected = true;
    this._selectedPartList.push(part);
    this._categoryMap.set(part.category || part.uuid, part);
    this._selectedPartList$.next(this._selectedPartList);
    this._categoryMap$.next(this._categoryMap);
  }

  removePart(part: PartModel) {
    part.isSelected = false;
    this._selectedPartList = this._selectedPartList.filter((p) => p.uuid !== part.uuid);
    this._categoryMap.delete(part.category || part.uuid);
    this._selectedPartList$.next(this._selectedPartList);
    this._categoryMap$.next(this._categoryMap);
  }
}
